import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/Home.css'
import '../css/Animation.css'
import '../css/Common-style.css'
import Me from '../images/bg-remove.png';

const Home = ()=>{
    return(
        <section id="Home">
        <div className="container-fluid">
            <div className="row home">
                <div className="col-md-6 blob">
                    <svg className="blob-shape" viewBox="0 0 200 187">
                        <mask id="mask0" mask-type="alpha">
                        <path d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 165.547 
                        130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 129.362C2.45775 
                        97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 -0.149132 97.9666 
                        0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z"/>
                        </mask>
                        <g mask="url(#mask0)">
                        <path d="M190.312 36.4879C206.582 62.1187 201.309 102.826 182.328 134.186C163.346 
                        165.547 130.807 187.559 100.226 186.353C69.6454 185.297 41.0228 161.023 21.7403 
                        129.362C2.45775 97.8511 -7.48481 59.1033 6.67581 34.5279C20.9871 10.1032 59.7028 
                        -0.149132 97.9666 0.00163737C136.23 0.303176 174.193 10.857 190.312 36.4879Z"/>
                        <image className="blob-image" href={Me}/>
                        </g>
                    </svg>
                </div>

                <div className="col-md-6 intro">
                    <p className="home-text"><span className="name">Hi, I'am N Giridhara Holla </span><br/><span className="job-title">Web Developer</span><br/><br/><span className="job-des">A full stack developer and enthusiastic engineering fresher who specializes in creating aesthetic web pages. </span></p>
                    <button className="btn btn-primary home-btn"><a href="#Projects">See more</a></button>
                </div>
            </div>
        </div>
        </section>
        
    );
}

export default Home;